import call from "../../../dashboard/service/http";
import constants from "./bioConstants";

export default {
  state: {
    bioData: {},
  },
  mutations: {
    SET_BIO_DATA: (state, payload) => {
      state.bioData = payload;
    },
  },
  getters: {
    bioData: (state) => state.bioData,
  },
  actions: {
    editbiodata: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", constants.editbiodata, data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          // back to biodata
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    updateNested: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.updateNested, data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.data);
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
